import { Outlet, useParams } from 'react-router-dom'

import { t } from '../../i18n'
import { PropertyList } from './PropertyList'

/**
 * The inventory: the list of properties on the left, the one being worked on
 * beside it.
 *
 * The same nested-route shape as the inbox, and for the same reason: the list
 * stays mounted while properties are opened, so the scroll position and the page
 * already fetched survive going back.
 */
export function ObjectsLayout() {
  const { propertyId } = useParams<{ propertyId: string }>()

  return (
    <div className="inbox">
      <section className="inbox__list" aria-label={t('objects.listTitle')}>
        <header className="inbox__header">
          <h1 className="inbox__title">{t('objects.listTitle')}</h1>
        </header>
        <PropertyList selected={propertyId ?? null} />
      </section>

      <section className="inbox__detail">
        <Outlet />
      </section>
    </div>
  )
}

/** Shown in the right-hand pane before a property is chosen. */
export function NoPropertyChosen() {
  return (
    <div className="empty-pane">
      <p className="empty-pane__title">{t('objects.pick')}</p>
      <p className="empty-pane__hint">{t('objects.description')}</p>
    </div>
  )
}
